import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

// Example: 20 de diciembre de 2018 (includeTime = false)
// Example: 20 de diciembre de 2018 17:52 (includeTime = true)
// Example: 20 de dic. de 2018 (monthShort = false)
function FormalDate({ value, children, includeTime, monthShort }) {
  const timeProps = {};
  if (includeTime) {
    timeProps.hour = 'numeric';
    timeProps.minute = 'numeric';
  }

  return (
    <FormattedDate
      value={value}
      day="numeric"
      month={monthShort ? 'short' : 'long'}
      year="numeric"
      {...timeProps}
    >
      {formattedDate => children(formattedDate)}
    </FormattedDate>
  );
}

FormalDate.propTypes = {
  value: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  includeTime: PropTypes.bool,
  monthShort: PropTypes.bool,
};

FormalDate.defaultProps = {
  includeTime: false,
  monthShort: false,
};

export default FormalDate;
